<template>
    <div v-if="isShowModal" ref="favModalRef" class="fav-login-tips__wrapper" 
        :class="[favLoginTips.type ? favLoginTips.type : 'left', themeMode === 'dark' ? 'dark-mode' : '']" tabindex="0" :style="{ top: style.top, left: style.left }">
        <div class="relative fav-tips-box">
            <div class="fav-login-tips__arrow">
                <svg width="39" height="33" viewBox="0 0 39 33" fill="none">
                    <path d="M19.5 0L38.1195 32.25H0.880453L19.5 0Z" fill="var(--color-background-default-secondary)"/>
                </svg>
            </div>
            <div class="fav-login-tips__container" >
                <p class="fav-login-tips__title" @click="handleBodyClick($event)">
                    {{ $t(favLoginTips.title) }}
                </p>
                <p class="fav-login-tips__text" @click="handleBodyClick($event)">{{ $t(favLoginTips.message) }}</p>
                <div class="fav-login-tips__footer">
                    <router-link :to="{ name: 'signin' , query: { callBackUrl: favLoginTips.callBackUrl } }" @click="toggleFavModal({ 'isClose' : true})" class="nav-pill selected">{{ $t("SIGN_IN") }}</router-link>
                    <router-link :to="{ name: 'signup' , query: { callBackUrl: favLoginTips.callBackUrl } }" @click="toggleFavModal({ 'isClose' : true})" class="nav-pill">{{ $t("JOIN_NOW") }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            isShowModal: false,
            style: {
                top: '',
                left: ''
            }
        }
    },
    watch:{
        favLoginTips: {
            deep: true,
            handler(news, prev) {    
                if (news.isOpen) {
                    this.handleOpen(news.event, news.triggerOnParent); 
                } else {
                    this.handleClose()
                }
            }
        },
   },
    computed:{
        ...mapState(['themeMode']),
        ...mapGetters([              
            'isMobile',
            'favLoginTips'
       ]),
    },
    mounted() {
        document.addEventListener('click', this.documentClick);
    },
    methods: {
        ...mapActions([
            "toggleFavModal"
        ]),
        handleOpen(event, triggerOnParent) {
            let targetedElement = event.target;
            if (triggerOnParent) {
                targetedElement = event.currentTarget;
            }
            this.isShowModal = true;

            this.$nextTick(() => {
                let favModalRef = this.$refs.favModalRef;
                if (this.favLoginTips.type === 'top') {
                    this.style.top = `${ this.getOffset(targetedElement).bottom }px`
                    this.style.left = `${ this.getOffset(targetedElement).right - (this.getOffset(targetedElement).width/2) - (favModalRef.getBoundingClientRect().width/2) }px`
                } else {
                    this.style.top = `${ this.getOffset(targetedElement).top - (favModalRef.getBoundingClientRect().height/2) + (targetedElement.getBoundingClientRect().height/2) }px`
                    this.style.left = `${ this.getOffset(targetedElement).left + (targetedElement.getBoundingClientRect().width) + 2 }px`
                }
            });
            event.stopPropagation();
        },

        handleClose() {
            this.isShowModal = false;
        },

        documentClick(e) {
            this.handleClose();
            e.stopPropagation();
        },
        
        getOffset(el) {
            const rect = el.getBoundingClientRect();
            return {
                left: rect.left + window.scrollX,
                right: rect.right + window.scrollX,
                top: rect.top + window.scrollY,
                bottom: rect.bottom + window.scrollY,
                width: rect.width
            };
        },

        handleBodyClick(event) {
            event.stopPropagation();
        }
    },
}
</script>

<style>
.fav-login-tips__wrapper{
    position: absolute;
    display: flex;
    align-items: center;
    z-index: 10;
}
.fav-login-tips__wrapper.top{
    flex-direction: column;
}
.fav-login-tips__container{
    background-color: var(--color-background-default-secondary);
    color: var(--color-text-default-default);
    padding: 24px 32px;
    width: 400px;
    box-sizing: border-box;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    z-index: 10;
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16); */
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 16px rgba(0, 0, 0, 0.16);
    animation: Popup .2s;
    transform-origin: 50% 0%;
    position: relative;
}
.fav-login-tips__container:after {
    content: '';
    width: 35px;
    height: 2px;
    background: var(--color-background-default-secondary);
    position: absolute;
    top:0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    display: block;
}
@keyframes Popup {
    from {
        transform: scale(0);
    } to {
        transform: scale(1);
    }
}
.fav-login-tips__arrow{
    position: relative;
    top: 3px;
    left: 50%;
    transform: translateX(-50%);
    width: 39px;
    height: 33px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 16px rgba(0, 0, 0, 0.16);
    background: var(--color-background-default-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
    z-index: 100;
    transform-origin: 100% 100%;
}
.fav-login-tips__arrow svg{
    transform: rotate(150deg);
}
.fav-login-tips__arrow path{
    fill: var(--color-background-default-secondary);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)) drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.16));

}
/* .fav-login-tips__wrapper.top .fav-login-tips__arrow{
    position: relative;
    bottom: -5px;
    left: 0;
} */
.fav-login-tips__wrapper.top .fav-login-tips__arrow svg{
    transform: rotate(0);
}
.fav-login-tips__footer{
    /* display: flex; */
}
.fav-login-tips__footer .nav-pill {
    display: block;
    padding: 12px;
    margin-bottom: 8px;
    border-radius: 8px;
    font-size: 16px;
    border: 1px solid transparent;
	letter-spacing: 0.64px;
}
.fav-login-tips__footer .nav-pill.selected:hover {
   background-color: var(--bg-selected) !important;
   color: var(--color-button-active) !important;
}
.fav-login-tips__footer .nav-pill:hover {
   background-color: var(--color-background-default-secondary) !important;
   color: var(--color-background-success-default) !important;
   border: 1px solid transparent;
}
.fav-login-tips__footer .nav-pill:last-child {
    margin-bottom: 0;
}
.fav-login-tips__title {
    color: var(--color-text-default-default);
    font-size: var(--typography-heading-size-extra-small);
    padding-bottom: 24px;
    font-family: var(--weight-600);
    width: 100%;
}
.fav-login-tips__text{
    margin-bottom: 32px;
    font-size: 16px;
	letter-spacing: 0.64px;
}
.fav-tips-box {
    transform: translateY(10px);
}

.fav-login-tips__arrow:after {
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translate3d(-50%, 0 ,0);
    width: 36px;
    height: 5px;
    background-color: var(--color-background-default-secondary);
    display: block;
    content: "";
}
.left .fav-login-tips__arrow {
    top: calc(262.57px / 2);
    left: 0;
    
}
.left .fav-login-tips__arrow:after {
    
    top: 0px;
    left: 30px;
    transform: translate3d(-50%, 0, 0);
    width: 20px;
    height: 36px;
}
.left .fav-tips-box {
    left: 20px;
}
</style>